// ink-component
import React, { ReactNode, LiHTMLAttributes } from 'react';

import getGlobalProps from '../../helpers/constants/global-props';

export interface LiProps extends LiHTMLAttributes<HTMLLIElement> {
  /** Content */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Be an item in an ordered or unordered list of textual elements
 * @categories layout
 * @group SimpleList
 * @aka list item
 */
export function Li(props: LiProps) {
  const { style, className, ...otherProps } = props;

  return <li {...otherProps} {...globalProps} />;
}

Li.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

Li.displayName = 'Li';

export default Li;
